import React from 'react';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';
import {conditionalStyles} from '../../../../utils/ThemeUtils';

const ToolbarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;

    ${p => p.theme.muiTheme.breakpoints.down('sm')} {
        flex-direction: column;
        align-items: unset;
    }
`;

const ToolbarContentWrapper = styled.div`
    display: flex;

    ${p => p.theme.muiTheme.breakpoints.up('sm')} {
        & > * + * {
            ${p =>
                conditionalStyles(p.theme.muiTheme.direction === 'ltr')(
                    'margin-left: 10px',
                    'margin-right: 10px'
                )};
        }
    }

    ${p => p.theme.muiTheme.breakpoints.down('sm')} {
        flex-direction: column;
        & > * + * {
            margin: 10px 0 0 0;
        }
    }
`;

const ToolbarHeader = styled(Skeleton)`
    ${p => p.theme.muiTheme.breakpoints.down('sm')} {
        margin-bottom: 10p;
    }
`;

const ToolbarButtons = styled(Skeleton)`
    width: 206px;
    ${p => p.theme.muiTheme.breakpoints.down('sm')} {
        width: 100%;
    }
`;

const ToolbarSkeleton = () => (
    <ToolbarWrapper>
        <ToolbarHeader width={250} height={40} />
        <ToolbarContentWrapper>
            <ToolbarButtons height={55} />
            <ToolbarButtons height={55} />
        </ToolbarContentWrapper>
    </ToolbarWrapper>
);

export default ToolbarSkeleton;
